import React from "react";
import { withRouter } from "react-router-dom";
import "../Styles/_FulfillmentInformation.css";
import { Warning, Confirmed } from "./_Icon";
import { orderUtils } from "../Helpers/OderUtils";

const FulfillmentInformation = props => {
    const getFulfilledSubOrders = () => {
        let sub_orders = props.order.sub_orders;
        let fulfilled_sub_orders = sub_orders.filter(sub_order => sub_order.fulfillment && sub_order.fulfillment.tracking_company);
        return fulfilled_sub_orders;
    };

    const isDelivered = sub_order => {
        const deliveredStatus = sub_order.order_statuses.find(status => status.status === "DELIVERED");
        return deliveredStatus && deliveredStatus.date;
    };

    const isOrderProcessed = order => {
        let sub_orders = order.sub_orders;
        return sub_orders && sub_orders.some(sub_order => sub_order.order_statuses.some(status => status.status === "PROCESSED" && status.date !== null));
    };

    let currentLanguage = props.currentLanguage;
    let fulfilled_sub_orders = getFulfilledSubOrders();

    if (
        orderUtils.orderIsCancelled(props.order) ||
        orderUtils.getItemsThatRequireShipping(props.order).length === 0 ||
        (fulfilled_sub_orders.length > 0 &&
            fulfilled_sub_orders.every(so => orderUtils.getCurrentSubOrderStatus(so) && orderUtils.getCurrentSubOrderStatus(so).status === "AUTHORIZED"))
    ) {
        return false;
    }

    if (fulfilled_sub_orders.length === 0) {
        return (
            <div>
                <div className="fulfillment-container allow-focus" tabIndex="0">
                    <div className="fulfillment-container-label">
                        <Warning />
                        {isOrderProcessed(props.order) ? (
                            <p>{currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.WAREHOUSE_MESSAGE}</p>
                        ) : (
                            <p>{currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.SHIPMENT_PENDING_MESSAGE}</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    const showTrackingButton = fulfillment => {
        if (!fulfillment || !fulfillment.shipping_date) {
            return false;
        }

        let now = new Date();
        let timeDifference = now.getTime() - new Date(fulfillment.shipping_date).getTime();
        let daysDifference = timeDifference / (1000 * 60 * 60 * 24);

        if (daysDifference > 30) {
            return false;
        }

        return true;
    };

    return (
        <div className="fulfillment-information-container">
            {fulfilled_sub_orders.map((sub_order, index) => {
                return (
                    <div key={index} className="fulfillment-container">
                        <div className="fulfillment-container-label">
                            <Confirmed />
                            {isDelivered(sub_order) ? (
                                <p>
                                    {`${currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.TRACKING_DELIVERED_MESSAGE} ${sub_order.fulfillment.tracking_company} ${sub_order.fulfillment.tracking_number}.`}
                                </p>
                            ) : (
                                <p>
                                    {`${currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.TRACKING_SHIPPED_MESSAGE} ${sub_order.fulfillment.tracking_company} ${sub_order.fulfillment.tracking_number}.`}
                                </p>
                            )}
                        </div>
                        {showTrackingButton(sub_order.fulfillment) && (
                            <div className="fulfillment-container-button">
                                <a
                                    type="button"
                                    href={sub_order.fulfillment.tracking_url}
                                    className="fulfillment-track"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.TRACKING_BUTTON_MESSAGE}
                                </a>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(FulfillmentInformation);



// WEBPACK FOOTER //
// ./src/views/Order/components/_FulfillmentInformation.jsx